/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountCredentialsBaseForAiPlatform extends models.ServiceAccountCredentialsBase {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountCredentialsBaseForAiPlatform");
    }

    getFixupPrototypeFunction() { return ServiceAccountCredentialsBaseForAiPlatform.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountCredentialsBaseForAiPlatform>): ServiceAccountCredentialsBaseForAiPlatform {
        let obj = Object.assign(new ServiceAccountCredentialsBaseForAiPlatform(), model);
        ServiceAccountCredentialsBaseForAiPlatform.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountCredentialsBaseForAiPlatform>): ServiceAccountCredentialsBaseForAiPlatform {
        if (!model) return null;
        return ServiceAccountCredentialsBaseForAiPlatform.newInstance(<ServiceAccountCredentialsBaseForAiPlatform> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountCredentialsBaseForAiPlatform) {
        if (!obj) return;

        models.ServiceAccountCredentialsBaseForAiPlatform.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountCredentialsBaseForAiPlatform): boolean {
        if (models.ServiceAccountCredentialsBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountCredentialsBaseForAiPlatform.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
